"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lib_1 = require("./lib");
var classNames_1 = __importDefault(require("../../../lib/classNames"));
var getEffectiveImageSize_1 = __importDefault(require("../lib/getEffectiveImageSize"));
var UploadcareImage = function (props) {
    var className = props.className, containerClassName = props.containerClassName, alt = props.alt, layout = props.layout, objectFit = props.objectFit, imageDetails = props.imageDetails, width = props.width, height = props.height, src = props.src, objectPosition = props.objectPosition, lazy = props.lazy;
    var _a = lib_1.getPictureDetails(props), sources = _a.sources, image = _a.image;
    var imageStyle = layout === 'fixed'
        ? undefined
        : {
            objectFit: objectFit,
            objectPosition: objectPosition,
            maxHeight: height,
            maxWidth: width,
            minHeight: height,
            minWidth: width,
        };
    var imageSize = getEffectiveImageSize_1.default(width, height, imageDetails);
    var altText = alt || (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.filename);
    return (react_1.default.createElement("picture", { className: classNames_1.default('uploadcare-image__picture', containerClassName) },
        sources.map(function (source) { return (react_1.default.createElement("source", { key: "" + (src || (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.uuid)) + source.id, srcSet: source.srcSet, type: source.type, media: source.media })); }),
        react_1.default.createElement("img", __assign({}, imageSize, { className: classNames_1.default(className, 'uploadcare-image__image', layout === 'fill' && 'uploadcare-image__layout-fill'), loading: lazy ? 'lazy' : 'eager', alt: altText, style: imageStyle, src: image.src }))));
};
exports.default = UploadcareImage;
//# sourceMappingURL=Image.js.map